import { SyntheticEvent, useEffect, useState } from 'react';
import React, { Suspense, useRef } from 'react';
import { isArray } from 'lodash';
import { Button, Form, Modal } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import agent from '../../../app/api/agent';
import Components from '../../../app/common/components';
import { ThreeDotLoader } from '../../../app/layout/LoadingComponent';
import { MetaDataOptions } from '../../../app/models/metaDataConfig';
// import { MetaDataElement } from "../../../app/models/metaDataConfig";
import { IFormDetails } from '../../../app/stores/dashboardConfiguration/types';
import { useStore } from '../../../app/stores/store';
import { PhotoType } from '../../MediaAssets/Details/CamModal';
import { FileType } from '../../MediaAssets/Details/FileUpload';
import './styles.css';
import { columnType } from '../../../app/common/components/DynamicRowsComponent';
import { GetCurrentUser } from '../../../app/models/user';
import { PDFDownloadLink } from '@react-pdf/renderer';
import LvpcmsInvoice from './LvpcmsInvoice';

const CamModal = React.lazy(() => import('../../MediaAssets/Details/CamModal'));

function FormComponentDyDb({
  formDetails,
  saveHandler,
  loader,
  submitBtnName,
  cancelBtnName,
  formName,
  cancelBtnMode,
  submitBtnMode,
  linkColumnName,
  linkColumnValue,
  assetId,
  dataGridName,
}: {
  formDetails: IFormDetails[];
  saveHandler: (formDetails: IFormDetails[]) => void;
  loader: {
    content: boolean;
    submit: boolean;
  };
  submitBtnName?: string;
  cancelBtnName?: string;
  formName?: string;
  cancelBtnMode?: number;
  submitBtnMode?: number;
  linkColumnName?: string;
  linkColumnValue?: string;
  assetId?: string;
  dataGridName?: string;
}) {
  const { commonStore, modalStore, DynamicDashboardStore, userStore } =
    useStore();
  const [duplicateFormDetails, setDuplicateFormDetails] = useState<
    IFormDetails[]
  >([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCamModalOpen, setIsCamModalOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [mastersList, setMasterList] = useState<any>({});
  const [userList, setUserList] = useState<any>({});
  const [, setTemporaryFilePath] = useState<string[]>([]);
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [updateMaster, setUpdateMaster] = useState<boolean>(false);

  const mandatoryFieldsRef = useRef<any>({});
  const copyOfForm = useRef<any>({});
  const hasElements = useRef(false);

  useEffect(() => {
    if (formDetails) {
      let res = formDetails?.filter(
        (data: { enableByDefault: boolean }) => data.enableByDefault,
      );
      if (res?.length === 0) {
        hasElements.current = false;
      } else {
        hasElements.current = true;
      }
      copyOfForm.current = JSON.parse(JSON.stringify(formDetails));
    }
  }, [formDetails]);

  useEffect(() => {
    const assetToBeRented = duplicateFormDetails.find(
      (detail) => detail.elementName === 'Asset to be Rented',
    )?.elementValue;
    if (assetToBeRented) {
      try {
        const rentalItems = JSON.parse(assetToBeRented.split('|')[1]);

        // Initialize the total rental amount and total rental quantity
        let totalRentalAmount = 0;
        let totalRentalQuantity = 0;

        // Loop through the rental items and calculate the totals
        rentalItems.forEach((item: any) => {
          const amount = parseFloat(item['Amount']) || 0;
          const quantity = parseInt(item['Quantity']) || 0;

          totalRentalAmount += amount;
          totalRentalQuantity += quantity;
        });

        // Update "Total Rental Amount" and "Total Rental Quantity" in duplicateFormDetails
        setDuplicateFormDetails((prevDetails) =>
          prevDetails.map((detail) =>
            detail.elementName === 'Total Rental Amount' ||
            detail.elementName === 'Total Rental Quantity'
              ? {
                  ...detail,
                  elementValue:
                    detail.elementName === 'Total Rental Amount'
                      ? totalRentalAmount.toString()
                      : totalRentalQuantity.toString(),
                }
              : detail,
          ),
        );
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    }
    // eslint-disable-next-line
  }, [
    // eslint-disable-next-line
    duplicateFormDetails.find(
      (detail) => detail.elementName === 'Asset to be Rented',
    )?.elementValue,
    // eslint-disable-next-line
  ]);

  useEffect(() => {
    function setTotalRentalAmountToEmpty() {
      setDuplicateFormDetails((prevDetails) =>
        prevDetails.map((detail) =>
          detail.elementName === 'Total Rental Amount'
            ? { ...detail, elementValue: '' }
            : detail,
        ),
      );
    }
    setTotalRentalAmountToEmpty();
  }, []);
  useEffect(() => {
    const datePartsToObject = (dateValue: any) => {
      const [day, month, year] = dateValue.split('/').map(Number);
      return new Date(year, month - 1, day);
    };

    const calculateTotalRentalAmount = (
      noOfUnits: any,
      rentPerDay: any,
      rentingDate: any,
      returnDate: any,
    ) => {
      const daysRented = Math.ceil(
        (returnDate - rentingDate) / (1000 * 60 * 60 * 24),
      );
      return noOfUnits * rentPerDay * (daysRented + 1);
    };
    const noOfUnitsValue = duplicateFormDetails.find(
      (detail) => detail.elementName === 'No of Units',
    )?.elementValue;
    const rentPerDayValue = duplicateFormDetails.find(
      (detail) => detail.elementName === 'Rent per Day',
    )?.elementValue;
    const rentingDateValue = duplicateFormDetails.find(
      (detail) => detail.elementName === 'Renting Date',
    )?.elementValue;
    const returnDateValue = duplicateFormDetails.find(
      (detail) => detail.elementName === 'Return Date of Rental Asset',
    )?.elementValue;

    if (
      noOfUnitsValue &&
      rentPerDayValue &&
      rentingDateValue &&
      returnDateValue
    ) {
      const noOfUnits = parseFloat(noOfUnitsValue);
      const rentPerDay = parseFloat(rentPerDayValue);
      const rentingDate = datePartsToObject(rentingDateValue);
      const returnDate = datePartsToObject(returnDateValue);

      const calculatedTotalRentalAmount = calculateTotalRentalAmount(
        noOfUnits,
        rentPerDay,
        rentingDate,
        returnDate,
      );

      setDuplicateFormDetails((prevDetails) =>
        prevDetails.map((detail) =>
          detail.elementName === 'Total Rental Amount'
            ? {
                ...detail,
                elementValue: calculatedTotalRentalAmount.toString(),
              }
            : detail,
        ),
      );
    }
    // else {
    //   setTotalRentalAmountToEmpty();
    // }
    // eslint-disable-next-line
  }, [
    // eslint-disable-next-line
    duplicateFormDetails.find((detail) => detail.elementName === 'No of Units')
      ?.elementValue,
    // eslint-disable-next-line
    duplicateFormDetails.find((detail) => detail.elementName === 'Rent per Day')
      ?.elementValue,
    // eslint-disable-next-line
    duplicateFormDetails.find((detail) => detail.elementName === 'Renting Date')
      ?.elementValue,
    // eslint-disable-next-line
    duplicateFormDetails.find(
      (detail) => detail.elementName === 'Return Date of Rental Asset',
    )?.elementValue,
    // eslint-disable-next-line
  ]);
  // static (demo)
  // useEffect(() => {
  //   (async () => {
  //     const masterName =
  //       duplicateFormDetails?.[0]?.elementValue?.split('|')?.[0];
  //     if (masterName === 'Items') {
  //       let groupName =
  //         duplicateFormDetails?.[0]?.elementValue?.split('|')?.[1];
  //       if (!groupName?.length) return;
  //       let mastersHashmap: any = structuredClone(mastersList);
  //       let assetInVault = '';
  //       if (
  //         DynamicDashboardStore.staticSelectedCard === 'Prepare to Deliver' ||
  //         DynamicDashboardStore.staticSelectedCard === 'Registrar Approval' ||
  //         DynamicDashboardStore.staticSelectedCard === 'Ready to Deliver'
  //       ) {
  //         assetInVault = 'IN TRANSIT';
  //       } else if (DynamicDashboardStore.staticSelectedCard === 'Return') {
  //         assetInVault = 'OUTSIDE';
  //       } else if (
  //         DynamicDashboardStore.staticSelectedCard === 'Move to Store'
  //       ) {
  //         assetInVault = 'IN TRANSIT';
  //       }
  //       let result: any = await agent.Activities.getInventoryTitleAlone({
  //         title: groupName,
  //         assetInVault: assetInVault,
  //       });
  //       mastersHashmap[
  //         `${duplicateFormDetails?.[1]?.elementValue?.split('|')?.[0]}`
  //       ] = (result.data || [])?.map((data: string) => {
  //         return {
  //           key: data,
  //           value: data,
  //           text: data,
  //         };
  //       });
  //       setMasterList(mastersHashmap);
  //     }
  //   })();
  //   //eslint-disable-next-line
  // }, [duplicateFormDetails?.[0]?.elementValue?.split('|')?.[1]]);

  useEffect(() => {
    // masters
    let masterCompletedCount = 0;

    function updateMaster() {
      if (filterMasters?.length === masterCompletedCount) {
        setTimeout(() => {
          setMasterList(mastersHashmap);
        }, 100);
      }
    }

    let mastersHashmap: any = {};

    let filterMasters = duplicateFormDetails?.filter(
      (data: { elementType: string }) => data.elementType === 'Masters',
    );

    filterMasters?.forEach(async (data: any, index: number) => {
      let result: any;

      let masterName = data.elementValue?.split('|')?.[0] || '';

      try {
        // static (demo)
        // if (masterName === 'WorkLevel') {
        //   result = await agent.WorkLevels.lisInsideVaultWorklevel();
        //   let returnData = await (result || [])?.map((data: string) => {
        //     return {
        //       key: data,
        //       value: data,
        //       text: data,
        //     };
        //   });

        //   mastersHashmap[`${data.elementValue?.split('|')?.[0]}`] = returnData;

        //   masterCompletedCount += 1;
        //   updateMaster();
        // }
        //  if (masterName === 'Items') {
        //   let groupName = formDetails?.[0]?.elementValue?.split('|')?.[1] || ''; // if (groupName) {
        //   let assetInVault = '';
        //   if (
        //     DynamicDashboardStore.staticSelectedCard === 'Prepare to Deliver' ||
        //     DynamicDashboardStore.staticSelectedCard === 'Registrar Approval' ||
        //     DynamicDashboardStore.staticSelectedCard === 'Ready to Deliver'
        //   ) {
        //     assetInVault = 'IN TRANSIT';
        //   } else if (DynamicDashboardStore.staticSelectedCard === 'Return') {
        //     assetInVault = 'OUTSIDE';
        //   } else if (
        //     DynamicDashboardStore.staticSelectedCard === 'Move to Store'
        //   ) {
        //     assetInVault = 'IN TRANSIT';
        //   }
        //   result = await agent.Activities.getInventoryTitleAlone({
        //     title: groupName,
        //     assetInVault: assetInVault,
        //   });

        //   let returnData = await (result.data || [])?.map((data: string) => {
        //     return {
        //       key: data,
        //       value: data,
        //       text: data,
        //     };
        //   });

        //   mastersHashmap[`${data.elementValue?.split('|')?.[0]}`] = returnData;
        //   masterCompletedCount += 1;
        //   updateMaster();
        // } else {
        if (data.dependency !== undefined) {
          let returnDate = '';
          let receivingDate = '';
          duplicateFormDetails?.forEach((duplicate_data) => {
            if (commonStore.staticDemoChanges) {
              if (duplicate_data.elementName === 'Receiving Date') {
                receivingDate = duplicate_data.elementValue;
              }
              if (duplicate_data.elementName === 'Return Date') {
                returnDate = duplicate_data.elementValue;
              }
            }
            if (duplicate_data.elementType === 'Masters') {
              filterMasters?.forEach(async (fMaster) => {
                const elementValueOfDependency =
                  duplicate_data.elementValue?.split('|')[1];
                if (
                  fMaster.dependency?.basedOn === duplicate_data.elementName &&
                  elementValueOfDependency
                ) {
                  const masterName = fMaster?.elementValue.split('|')[0];

                  if (
                    masterName === 'Items' &&
                    !commonStore.staticDemoChanges
                  ) {
                    result = await agent.Activities.getInventoryTitleAlone({
                      title: elementValueOfDependency,
                      assetInVault: '',
                    });
                  } else {
                    let payload: any = {};
                    if (
                      masterName === 'Items' &&
                      commonStore.staticDemoChanges
                    ) {
                      if (
                        dataGridName === 'Report' ||
                        dataGridName === 'Approval Queue'
                      ) {
                        payload = {
                          assetReportId: assetId || '',
                          name: 'Asset List',
                          componentName: 'Asset Name',
                          filterColumn: 'Project',
                          filterValue: elementValueOfDependency,
                        };
                        result =
                          await agent.WorkLevels.mastersListAcademyAPI(payload);
                      } else {
                        payload = {
                          name: 'Asset List',
                          componentName: 'Asset Name',
                          filterColumn: 'Project',
                          filterValue: elementValueOfDependency,
                          receivingDate,
                          returnDate,
                        };
                        result = await agent.WorkLevels.mastersListAPI(payload);
                      }
                    } else {
                      payload = {
                        name: masterName,
                        componentName: fMaster?.selectMasterComponent || '',
                        filterColumn: fMaster.dependency?.checkWith,
                        filterValue: elementValueOfDependency,
                        receivingDate: '',
                        returnDate: '',
                      };
                      result = await agent.WorkLevels.mastersListAPI(payload);
                    }
                  }
                  let returnData = [];

                  if (masterName === 'Items' && commonStore.staticDemoChanges) {
                    const tempList: any = [];
                    returnData = await (result.data || [])?.map(
                      // eslint-disable-next-line
                      (optionValue: string) => {
                        if (!optionValue.split('|')[1]?.includes(',')) {
                          return {
                            key: optionValue.split('|')[1],
                            value: optionValue.split('|')[1],
                            text: optionValue.split('|')[1],
                          };
                        } else {
                          const temp = optionValue.split('|')[1]?.split(',');
                          for (var i = 0; i < temp.length; i++) {
                            tempList?.push({
                              key: temp[i],
                              value: temp[i],
                              text: temp[i],
                            });
                          }
                        }
                      },
                    );
                    if (tempList.length > 0) {
                      tempList?.forEach((t: any) => {
                        returnData.push(t);
                      });
                    }
                    returnData = returnData.filter((x: any) => x !== undefined);
                  } else {
                    returnData = await (result.data || [])?.map(
                      (optionValue: string) => {
                        return {
                          key: optionValue,
                          value: optionValue,
                          text: optionValue,
                        };
                      },
                    );
                  }
                  mastersHashmap[masterName] = returnData;
                  // setMasterList(mastersHashmap);
                }
              });
            }
          });
        } else {
          const payload = {
            name: masterName,
            componentName: data.selectMasterComponent,
            filterColumn: '',
            filterValue: '',
            receivingDate: '',
            returnDate: '',
          };
          if (masterName === 'WorkLevel') {
            result = await agent.WorkLevels.lisInsideVaultWorklevel();
          } else if (masterName === 'Items') {
            result = await agent.Activities.getInventoryTitleAlone({
              title: '',
              assetInVault: '',
            });
          } else {
            result = await agent.WorkLevels.mastersListAPI(payload);
          }
          let returnData = await (result?.data || result || []).map(
            (optionValue: any) => {
              if (typeof optionValue === 'object' && optionValue !== null) {
                if (userStore?.user?.customerName === 'Area 51') {
                  return {
                    key: optionValue.id || '',
                    value: optionValue.title + '//' + optionValue.id || '',
                    text: optionValue.title || '',
                  };
                } else {
                  return {
                    key: optionValue.id || '',
                    value: optionValue.title || '',
                    text: optionValue.title || '',
                  };
                }
              } else if (typeof optionValue === 'string') {
                return {
                  key: optionValue,
                  value: optionValue,
                  text: optionValue,
                };
              } else {
                return {
                  key: optionValue,
                  value: optionValue,
                  text: optionValue,
                };
              }
            },
          );

          mastersHashmap[`${data.elementValue?.split('|')?.[0]}`] =
            data.dependency !== undefined ? [] : returnData;
        }

        masterCompletedCount += 1;
        updateMaster();
        // }
      } catch {}
    }); // users

    let usersHashmap: any = {};
    let userCompletedCount = 0;

    function updateUsers() {
      if (filterUsers?.length === userCompletedCount) {
        setTimeout(() => {
          setUserList(usersHashmap);
        }, 100);
      }
    }

    let filterUsers = duplicateFormDetails?.filter(
      (data: { elementType: string }) => data.elementType === 'Users',
    );
    // This condition for demo login user affect so i used that code
    if (commonStore.markLoginStaticRegisterDemoChages) return;
    filterUsers?.forEach(
      async (
        data: { elementValue: string; elementName: string },
        index: number,
      ) => {
        let username = data.elementValue?.split('|')?.[0] || 'Admin';

        let result: any = await agent.WorkLevels.usersListAPI(username);
        let returnData = await (result || [])?.map((data: string) => {
          return {
            key: data,
            value: data,
            text: data,
          };
        });

        usersHashmap[`${data.elementValue?.split('|')?.[0]}`] = returnData;
        userCompletedCount += 1;
        updateUsers();
      },
    );

    let filterElementWithDependency = duplicateFormDetails?.filter(
      (data: any) =>
        data.dependency !== undefined &&
        data.elementType !== 'Masters' &&
        data.elementType !== 'Users',
    );
    filterElementWithDependency?.forEach((fElement) => {
      duplicateFormDetails?.forEach(async (duplicate_data) => {
        if (fElement?.dependency?.basedOn === duplicate_data.elementName) {
          // if(duplicate_data.elementType === 'Masters') {
          const payload = {
            name: duplicate_data.elementValue?.split('|')?.[0],
            componentName: fElement.elementName,
            filterColumn: duplicate_data.elementName,
            filterValue: duplicate_data.elementValue?.split('|')?.[1],
          };
          let result = await agent.WorkLevels.mastersListAPI(payload);
          if (fElement.elementType === 'DropDown') {
            const tempOptions = result.data?.join('|');
            fElement.elementValue = tempOptions;
          } else {
            fElement.elementValue = result.data[0];
          }
          fElement.mode = 0;
        }
      });
    });

    if (commonStore.staticDemoChanges) {
      let tempMinDay = '0',
        tempMinDayRental = '0',
        tempMinMonth = '0',
        tempMinMonthRental = '0',
        tempMinYear = '0',
        tempMinYearRental = '0';
      let tempDate = new Date().toLocaleDateString('en-IN', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        }),
        tempDateRental = new Date().toLocaleDateString('en-IN', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        });
      let dateElements = duplicateFormDetails?.filter(
        (data: any) => data.elementType === 'DatePicker',
      );
      dateElements?.forEach((dt: any) => {
        if (dt.elementName === 'Receiving Date') {
          const split = dt.elementValue?.split('/');
          tempMinDay = split?.[0] || '0';
          tempMinMonth = split?.[1] || '0';
          tempMinYear = split?.[2] || '0';
          tempDate = dt.elementValue;
        }
        if (dt.elementName === 'Renting Date') {
          const split = dt.elementValue?.split('/');
          tempMinDayRental = split?.[0] || '0';
          tempMinMonthRental = split?.[1] || '0';
          tempMinYearRental = split?.[2] || '0';
          tempDateRental = dt.elementValue;
        }
        if (dt.elementName === 'Return Date') {
          const split = dt.elementValue?.split('/');
          if (
            split?.[2] <= tempMinYear &&
            split?.[1] <= tempMinMonth &&
            split?.[0] < tempMinDay
          ) {
            dt.elementValue = tempDate;
          }
        }
        if (dt.elementName === 'Return Date of Rental Asset') {
          const split = dt.elementValue?.split('/');
          if (
            split?.[2] <= tempMinYearRental &&
            split?.[1] <= tempMinMonthRental &&
            split?.[0] < tempMinDayRental
          ) {
            dt.elementValue = tempDateRental;
          }
        }
      });
    }
    // eslint-disable-next-line
  }, [updateMaster]);

  useEffect(() => {
    const copyEle = [...formDetails];
    copyEle?.forEach((duplicate_data) => {
      if (
        duplicate_data.elementType === 'DatePicker' &&
        duplicate_data.elementValue === ''
      ) {
        duplicate_data.elementValue = new Date().toLocaleDateString('en-IN', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        });
      }
      if (
        duplicate_data.elementType.includes('CurrentUser') &&
        duplicate_data.elementValue === '' &&
        duplicate_data.mode !== 2
      ) {
        const autoVal = duplicate_data.elementType.split('|')?.[1];
        switch (autoVal) {
          case 'displayNameWithTimeStamp':
            duplicate_data.elementValue = `By ${userStore?.user
              ?.displayName} on ${new Date()}`;
            break;
          case 'timeStamp':
            duplicate_data.elementValue = new Date().toString();
            break;
          default:
            duplicate_data.elementValue =
              userStore?.user?.[autoVal as string as keyof GetCurrentUser];
            break;
        }
      }
    });
    setUpdateMaster(!updateMaster);
    setDuplicateFormDetails(copyEle);
    // eslint-disable-next-line
  }, [formDetails]);

  useEffect(() => {
    let errorMessageLocal: any = {};
    if (
      JSON.stringify(copyOfForm.current) ===
      JSON.stringify(duplicateFormDetails)
    )
      return;
    duplicateFormDetails?.forEach((metadata) => {
      const {
        readOnly,
        enableByDefault,
        elementType,
        elementValue,
        elementId,
        validation,
        isMandatory,
        files,
        photos,
        mode,
      } = metadata || {};
      if (readOnly || !enableByDefault) return;
      if (mode === 2 || mode === 0) return;

      let result = '';
      if (/textbox/gi.test(elementType) && elementValue) {
        result = commonStore.genericValidation(
          elementValue || '',
          validation || '',
        );
      }

      if (result?.length) {
        errorMessageLocal[`${elementId}`] = result;
      } else if (elementType === 'DynamicTable' && isMandatory) {
        const stringData = elementValue?.split('DynamicTable|')?.[1];
        let tempValue = stringData !== undefined ? JSON.parse(stringData) : [];
        if (tempValue.length === 0) {
          errorMessageLocal[`${elementId}`] = 'This is a mandatory field';
        } else {
          let columnHeaders: string[] = [];
          if (tempValue[0]) {
            columnHeaders = Object.keys(tempValue[0]);
            columnHeaders = columnHeaders?.filter((data) => data !== ' uuid ');
          }
          let count = 0;
          columnHeaders = columnHeaders?.filter((data) => data !== '_uuid_');
          tempValue?.forEach((tableRowData: any) => {
            columnHeaders?.forEach((header: string) => {
              if (tableRowData[header] === '') {
                count++;
              }
            });
          });
          if (count) {
            errorMessageLocal[`${elementId}`] = 'This is a mandatory field';
          } else {
            delete errorMessageLocal[`${elementId}`];
          }
        }
      } else if (
        (elementType === 'AddFiles' && isMandatory && files.length === 0) ||
        (elementType === 'AddPhotograph' && isMandatory && photos.length === 0)
      ) {
        errorMessageLocal[`${elementId}`] = 'This is a mandatory field';
      } else if (
        isMandatory &&
        elementValue?.length === 0 &&
        elementType !== 'AddFiles' &&
        elementType !== 'AddPhotograph'
      ) {
        errorMessageLocal[`${elementId}`] = 'This is a mandatory field';
      } else if (
        isMandatory &&
        !elementValue?.split('|')?.[1] &&
        elementType === 'Masters'
      ) {
        errorMessageLocal[`${elementId}`] = 'This is a mandatory field';
      } else {
        delete errorMessageLocal[`${elementId}`];
      }

      /**
       * Mandatory
       */

      if (
        (elementType === 'AddFiles' &&
          (/mandatory/gi.test(validation) || isMandatory) &&
          files.length === 0) ||
        (elementType === 'AddPhotograph' &&
          (/mandatory/gi.test(validation) || isMandatory) &&
          photos.length === 0)
      ) {
        mandatoryFieldsRef.current[`${elementId}`] = elementId;
      } else if (
        elementType !== 'AddPhotograph' &&
        elementType !== 'AddFiles' &&
        elementValue?.length === 0 &&
        (/mandatory/gi.test(validation) || isMandatory)
      ) {
        mandatoryFieldsRef.current[`${elementId}`] = elementId;
      } else if (
        (elementType === 'Users' || elementType === 'Masters') &&
        elementValue?.split('|')?.[1] === undefined &&
        (/mandatory/gi.test(validation) || isMandatory)
      ) {
        mandatoryFieldsRef.current[`${elementId}`] = elementId;
      } else {
        delete mandatoryFieldsRef.current[`${elementId}`];
      }

      setErrorMessage(errorMessageLocal);
    });
    // eslint-disable-next-line
  }, [duplicateFormDetails]);

  const saveDynamicTableData = async (
    data: any,
    validationData: any,
    removed: any,
    added: any,
    // alterHistory: string,
    initialElementValue: any,
    headers: columnType[],
  ) => {
    let copyElements = [...duplicateFormDetails];
    let indexOfData = copyElements?.findIndex(
      (localData: { templateElementId: string }) =>
        localData?.templateElementId === validationData?.templateElementId,
    );
    let payload = {
      ...validationData,
      elementValue: 'DynamicTable|' + JSON.stringify(data),
    };
    if (indexOfData < 0) {
      copyElements?.push(payload);
    } else {
      if (copyElements[indexOfData]) {
        copyElements[indexOfData] = payload;
      }
    }
    setDuplicateFormDetails(copyElements);
  };

  const getUploadedFiles = (uploadedFiles: FileType, index: number) => {
    let temp: any = [];
    if (uploadedFiles?.url) {
      setTemporaryFilePath((temporaryFilePath) => [
        ...temporaryFilePath,
        uploadedFiles.url,
      ]);
    }
    if (uploadedFiles?.id !== '') {
      temp = [...duplicateFormDetails];
      for (let i = 0; i < temp.length; i++) {
        if (temp[i].elementId === index) {
          temp[i]?.files?.push(uploadedFiles);
        }
      }
      setDuplicateFormDetails(temp);
    }
  };

  const getUploadedPhotos = (uploadedPhotos: PhotoType, index: number) => {
    let temp: any = [];
    if (uploadedPhotos?.url) {
      setTemporaryFilePath((temporaryFilePath) => [
        ...temporaryFilePath,
        uploadedPhotos.url,
      ]);
    }
    if (uploadedPhotos?.id !== '') {
      temp = [...duplicateFormDetails];
      temp[index]?.photos?.push(uploadedPhotos);
      setDuplicateFormDetails(temp);
    }
    // setIsCamModalOpen(false);
  };

  const onPhotoClick = (index: number) => {
    setPhotoIndex(index);
    setIsCamModalOpen(true);
  };

  const collectSelectVal = (
    e: any,
    data: any,
    _optionData: MetaDataOptions[],
    index: number,
    isMultiple?: boolean,
    previousValue?: string,
  ) => {
    if (e.keyCode === 'Backspace' || e.keyCode === 'Delete') {
      e.stopPropagation();
      return;
    }
    let copy: any = [...duplicateFormDetails];

    function updateElementHandler() {
      for (let i = 0; i < copy?.length; i++) {
        if (copy[i].elementId === data.id) {
          let value = '';
          if (isArray(data.value)) {
            value = data.value.join('|');
          } else {
            value = data.value;
          }
          copy[i].elementValue = value;
        }
        for (let j = 0; j < copy[i]?.options?.length; j++) {
          let linkID = '';
          if (data.value?.includes(copy[i]?.options?.[j]?.optionName)) {
            linkID = copy[i]?.options?.[j]?.optionLinkId;
          }
          let newLinkId = linkID?.split('|');
          for (let x = 0; x < newLinkId?.length; x++) {
            let foundIndex = copy.findIndex(
              (localData: { templateElementId: string }) => {
                return newLinkId[x] === localData.templateElementId;
              },
            );
            if (copy?.[foundIndex] !== undefined) {
              if (
                copy?.[foundIndex].isMandatory &&
                copy?.[foundIndex]?.elementValue?.length === 0
              ) {
                mandatoryFieldsRef.current[`${copy?.[foundIndex].elementId}`] =
                  copy?.[foundIndex].elementId;
              }
              copy[foundIndex].enableByDefault = true;
            }
          }
        }
      }
    }

    if (!isMultiple) {
      let addLinkID = '';
      let removeLinkID = '';
      if (copy?.[index]) copy[index].elementValue = data.value;
      for (let j = 0; j < copy[index].options?.length; j++) {
        if (previousValue === copy[index]?.options?.[j]?.optionName) {
          removeLinkID = copy[index]?.options?.[j]?.optionLinkId;
        }
        if (data.value === copy[index]?.options?.[j]?.optionName) {
          addLinkID = copy[index]?.options?.[j]?.optionLinkId;
        }
      }
      for (let i = 0; i < copy?.length; i++) {
        if (copy[i]?.templateElementId === removeLinkID) {
          if (copy?.[i] !== undefined) {
            delete mandatoryFieldsRef.current[`${copy?.[i]?.elementId}`];
            copy[i].enableByDefault = false;
          }
        }
        if (copy[i]?.templateElementId === addLinkID) {
          if (copy?.[i] !== undefined) {
            if (
              /mandatory/gi.test(copy?.[i]?.validation) ||
              copy?.[i]?.isMandatory
            ) {
              mandatoryFieldsRef.current[`${copy?.[i]?.elementId}`] =
                copy?.[i].elementId;
            }
            copy[i].enableByDefault = true;
          }
        }
      }
      updateElementHandler();
    }
    if (e.target.className === 'delete icon') {
      for (let i = 0; i < copy?.length; i++) {
        let linkID = '';
        for (let j = 0; j < copy[i].options?.length; j++) {
          if (
            e.currentTarget.parentElement.text ===
            copy[i]?.options?.[j]?.optionName
          ) {
            linkID = copy[i]?.options?.[j]?.optionLinkId;
          }
        }
        let newLinkId = linkID?.split('|');
        for (let x = 0; x < newLinkId?.length; x++) {
          let foundIndex = copy.findIndex(
            (localData: { templateElementId: string }) =>
              newLinkId[x] === localData.templateElementId,
          );
          if (copy?.[foundIndex] !== undefined) {
            delete mandatoryFieldsRef.current[
              `${copy?.[foundIndex]?.elementId}`
            ];
            copy[foundIndex].enableByDefault = false;
          }
        }
      }
      updateElementHandler();
    } else {
      updateElementHandler();
    }
    setUpdateMaster(!updateMaster);
    setDuplicateFormDetails(copy);
  };

  const onConfirmUser = async (validationData: any) => {
    let copyElements = [...duplicateFormDetails];
    let indexOfData = copyElements?.findIndex(
      (localData: { templateElementId: string }) =>
        localData?.templateElementId === validationData?.templateElementId,
    );
    // let previousValue = copyElements[indexOfData]?.elementValue || '';
    let errorTemp = Object.assign({}, errorMessage);
    let result = '';
    let payload = {
      ...validationData,
      // Only for datepicker "e" is consider as a value
      elementValue: userStore.user?.displayName,
    };
    if (indexOfData < 0) {
      copyElements?.push(payload);
    } else {
      if (copyElements[indexOfData]) {
        copyElements[indexOfData] = payload;
      }
    }
    if (validationData?.isMandatory) {
      result = 'This is mandatory field';
    }
    if (result) {
      errorTemp[`${validationData?.elementId}`] = result;
      mandatoryFieldsRef.current[`${validationData?.elementId}`] =
        validationData?.elementId;
    } else {
      delete errorTemp[`${validationData?.elementId}`];
      delete mandatoryFieldsRef.current[`${validationData?.elementId}`];
    }
    setErrorMessage(errorTemp);
    setDuplicateFormDetails(copyElements);
  };

  const onChangeHandler = async (e: any, data: any, validationData: any) => {
    // Mark Login Static changes for  Advance Received....
    if (validationData.elementName === 'Advance Received') {
      if (data?.value === 'Yes') {
        commonStore.markLoginStaticChangesForCard = true;
      } else {
        commonStore.markLoginStaticChangesForCard = false;
      }
    }

    if (e.key === 'Backspace' || e.key === 'Delete') {
      e.stopPropagation();
      return;
    }

    if (
      validationData?.elementType === 'DatePicker' ||
      validationData?.elementType === 'DropDown'
    ) {
      setUpdateMaster(!updateMaster);
    }

    let copyElements = [...duplicateFormDetails];
    let indexOfData = copyElements?.findIndex(
      (localData: { templateElementId: string }) =>
        localData?.templateElementId === validationData?.templateElementId,
    );
    let previousValue = copyElements[indexOfData]?.elementValue || '';
    let errorTemp = Object.assign({}, errorMessage);
    let result = '';
    let value = /datepicker/gi.test(validationData?.elementType || '')
      ? e?.toLocaleDateString('en-IN', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        })
      : validationData?.elementType === 'DateTime'
        ? new Date(data).toDateString() +
          ' ' +
          new Date(data).toString().split(' ')[4]
        : data.value;

    let payload = {
      ...validationData,
      // Only for datepicker "e" is consider as a value
      elementValue: value,
    };
    if (indexOfData < 0) {
      copyElements?.push(payload);
    } else {
      if (copyElements[indexOfData]) {
        copyElements[indexOfData] = payload;
      }
    }
    if (/textbox/gi.test(validationData?.elementType || '')) {
      result = commonStore.genericValidation(
        value || '',
        validationData?.validation || '',
      );
    }
    if (validationData?.isMandatory && !value?.length) {
      result = 'This is mandatory field';
    }
    if (result) {
      errorTemp[`${validationData?.elementId}`] = result;
      mandatoryFieldsRef.current[`${validationData?.elementId}`] =
        validationData?.elementId;
    } else {
      delete errorTemp[`${validationData?.elementId}`];
      delete mandatoryFieldsRef.current[`${validationData?.elementId}`];
    }
    setErrorMessage(errorTemp);

    if (/dropdown/gi.test(validationData?.elementType || '')) {
      collectSelectVal(
        e,
        data,
        [],
        indexOfData,
        copyElements[indexOfData].isMultiple,
        previousValue,
      );
      return;
    }
    setDuplicateFormDetails(copyElements);
  };

  const mastersAndUsersHandler = async (e: any, data1: any) => {
    let copyElements = [...duplicateFormDetails];
    let findIndex = copyElements?.findIndex(
      (localData) => localData.elementName === data1.name,
    );
    let copyElementsWithDependency = copyElements?.filter(
      (el: any) => el.dependency !== undefined,
    );
    copyElementsWithDependency?.forEach((ele: any) => {
      if (data1.name === ele.dependency.basedOn) {
        if (ele.elementType === 'Masters') {
          ele.elementValue = `${ele.elementValue?.split('|')?.[0]}|${''}`;
        } else {
          ele.elementValue = '';
        }
      }
    });
    let masterOrUser = copyElements[findIndex].elementValue?.split('|');
    if (copyElements[findIndex]?.elementName === data1.name) {
      let name = masterOrUser?.[0] || 'Admin';
      let value = data1.value;
      value = `${name}|${value}`;
      copyElements[findIndex].elementValue = value;
    }

    if (masterOrUser) {
      delete mandatoryFieldsRef.current[`${copyElements[findIndex].elementId}`];
    } else {
      mandatoryFieldsRef.current[`${copyElements[findIndex].elementId}`] =
        copyElements[findIndex].elementId;
    }
    setDuplicateFormDetails(copyElements);
    if (
      data1.name === 'Services' &&
      commonStore.markLoginStaticRegisterDemoChages
    ) {
      let usersHashmap: any = {};
      let filterUsers = formDetails?.filter(
        (data: { elementType: string }) => data.elementType === 'Users',
      );
      filterUsers?.forEach(
        async (data: { elementValue: string }, index: number) => {
          let result: any = await agent.Departments.MarkloginUserDetails(
            data1.value,
          );
          let returnData = await (result.data || [])?.map((data: any) => {
            return {
              key: data.username,
              value: data.username,
              text: data.username,
            };
          });
          usersHashmap[`${data.elementValue?.split('|')?.[0]}`] = returnData;
          setTimeout(() => {
            setUserList(usersHashmap);
          }, 100);
        },
      );
    }
    setUpdateMaster(!updateMaster);
    // setLocalDataElement(copyElements);
  };

  const departHandler = (e: any, data: any) => {
    let copyElements = [...duplicateFormDetails];
    let findIndex = copyElements?.findIndex(
      (localData) => localData.elementName === data.name,
    );
    // for 8080 changes
    let value = data.value.join('|');
    //  let value = data.value;
    copyElements[findIndex].elementValue = value;
    if (value?.length) {
      delete mandatoryFieldsRef?.current[
        `${copyElements[findIndex]?.elementId}`
      ];
    } else {
      mandatoryFieldsRef.current[`${copyElements[findIndex]?.elementId}`] =
        copyElements[findIndex]?.elementId;
    }
    setDuplicateFormDetails(copyElements);
    // for 8080 changes
    userStore.UserNameAddMarkLogin(data.value[0]);
    // userStore.UserNameAddMarkLogin(data.value);
    // setLocalDataElement(copyElements);
  };

  const beforeSaveHandler = async () => {
    setIsSaveClicked(true);
    if (
      JSON.stringify(copyOfForm.current) ===
      JSON.stringify(duplicateFormDetails)
    ) {
      toast.info('Please make changes in order to save');
      return;
    }

    let isMandatory = false;

    for (let i = 0; i < duplicateFormDetails?.length; i++) {
      //------------ mandatory fields checking ------------//
      if (mandatoryFieldsRef.current[`${duplicateFormDetails[i].elementId}`]) {
        let localErrMsg = Object.assign({}, errorMessage);
        localErrMsg[`${duplicateFormDetails[i].elementId}`] =
          'This is mandatory field';
        isMandatory = true;
        setErrorMessage(localErrMsg);
      }
      if (
        commonStore.staticDemoChanges &&
        DynamicDashboardStore.staticSelectedCard === 'Approval' &&
        duplicateFormDetails[i].elementType === 'Masters' &&
        duplicateFormDetails[i].elementName === 'Select Asset'
      ) {
        copyOfForm.current?.forEach((data: any) => {
          if (
            data.elementType === 'Masters' &&
            data.elementName === 'Select Asset'
          ) {
            if (data.elementValue !== duplicateFormDetails[i].elementValue) {
              DynamicDashboardStore.assetChangedByHOD = true;
            }
          }
        });
      }
    }

    if (Object.keys(errorMessage)?.length) {
      let element = document.getElementById(Object.keys(errorMessage)[0]);
      element?.focus();
      toast.error('Kindly fill appropriate input');
      return;
    }

    if (isMandatory) {
      toast.error('Kindly fill appropriate input');
      return;
    }

    saveHandler(duplicateFormDetails);
    copyOfForm.current = JSON.parse(JSON.stringify(duplicateFormDetails));
    userStore.markloginDropDownTwo = false;
  };

  const disableGenerateInvoice = () => {
    if (submitBtnMode === 0) {
      return true;
    }
    if (
      JSON.stringify(copyOfForm.current) ===
      JSON.stringify(duplicateFormDetails)
    ) {
      return true;
    }
    let isMandatory = false;

    for (let i = 0; i < duplicateFormDetails?.length; i++) {
      //------------ mandatory fields checking ------------//
      if (mandatoryFieldsRef.current[`${duplicateFormDetails[i].elementId}`]) {
        let localErrMsg = Object.assign({}, errorMessage);
        localErrMsg[`${duplicateFormDetails[i].elementId}`] =
          'This is mandatory field';
        isMandatory = true;
        // setErrorMessage(localErrMsg);
      }
      if (duplicateFormDetails[i].elementType === 'DynamicTable') {
        let dynValue = duplicateFormDetails[i]?.elementValue;
        let tempValue = [];
        if (dynValue?.includes('DynamicTable|')) {
          let stringData = dynValue?.split('DynamicTable|')?.[1];
          stringData = stringData?.split('_')?.join(' ');
          tempValue = stringData !== undefined ? JSON.parse(stringData) : [];
          for (let j = 0; j < duplicateFormDetails[i].options?.length; j++) {
            if (duplicateFormDetails[i].options?.[j].isSelected) {
              tempValue?.forEach((t: any) => {
                if (
                  t?.[duplicateFormDetails[i].options?.[j]?.optionName] === ''
                ) {
                  return true;
                }
              });
            }
          }
        }
      }

      if (
        commonStore.staticDemoChanges &&
        DynamicDashboardStore.staticSelectedCard === 'Approval' &&
        duplicateFormDetails[i].elementType === 'Masters' &&
        duplicateFormDetails[i].elementName === 'Select Asset'
      ) {
        copyOfForm.current?.forEach((data: any) => {
          if (
            data.elementType === 'Masters' &&
            data.elementName === 'Select Asset'
          ) {
            if (data.elementValue !== duplicateFormDetails[i].elementValue) {
              DynamicDashboardStore.assetChangedByHOD = true;
            }
          }
        });
      }
    }

    if (Object.keys(errorMessage)?.length) {
      // let element = document.getElementById(Object.keys(errorMessage)[0]);
      // element?.focus();
      return true;
    }
    if (isMandatory) {
      return true;
    }
    return false;
  };

  return (
    <div className="dy-db-form-wrapper">
      {isModalOpen && (
        <Modal
          onClose={() => setIsModalOpen(false)}
          onOpen={() => setIsModalOpen(true)}
          open={isModalOpen}
        >
          <Modal.Header>Clear Form</Modal.Header>
          <Modal.Content>
            <div id="delete-modal">
              <p>
                You will lose your unsaved changes. Do you still wish to proceed
                ?
              </p>
              <Button.Group>
                <Button onClick={() => setIsModalOpen(false)}>No</Button>
                <Button.Or />
                <Button
                  positive
                  onClick={() => {
                    setIsModalOpen(false);
                    setDuplicateFormDetails(formDetails);
                    modalStore.modal.open = false;
                    modalStore.modal.body = null;
                  }}
                >
                  Yes
                </Button>
              </Button.Group>
            </div>
          </Modal.Content>
        </Modal>
      )}
      {isCamModalOpen && (
        <Suspense fallback={<>loading....</>}>
          <CamModal
            getUploadedPhotos={getUploadedPhotos}
            index={photoIndex}
            cancelHandler={() => {
              setIsCamModalOpen(false);
            }}
            fromDashboard
            duplicateFormDetails={duplicateFormDetails}
          />
        </Suspense>
      )}
      <Form className="dy-db-form">
        <div className="form-first-child">
          {loader.content ? (
            <ThreeDotLoader />
          ) : !hasElements.current ? (
            <h3>Sorry, No Data</h3>
          ) : (
            duplicateFormDetails?.map(
              (data, index) =>
                !commonStore.filterModeTwo?.includes(
                  data.templateElementId,
                ) && (
                  <Components
                    disabled={commonStore.filterModeZero?.includes(
                      data.templateElementId,
                    )}
                    key={data.elementId}
                    index={index}
                    elementDetails={data}
                    addPhotographsHandler={() => setIsCamModalOpen(false)}
                    onChangeHandler={onChangeHandler}
                    camImage={[]}
                    masterOptions={
                      (data.elementType === 'Masters' &&
                        mastersList[
                          `${
                            data.elementValue?.toString()?.split('|')?.[0] || ''
                          }`
                        ]) ||
                      []
                    }
                    usersOptions={
                      (data.elementType === 'Users' &&
                        userList[
                          `${
                            data.elementValue?.toString()?.split('|')?.[0] || ''
                          }`
                        ]) ||
                      []
                    }
                    errorMessage={isSaveClicked ? errorMessage : ''}
                    mastersHandler={(e: SyntheticEvent, data: any) =>
                      mastersAndUsersHandler(e, data)
                    }
                    usersHandler={(e: SyntheticEvent, data: any) =>
                      mastersAndUsersHandler(e, data)
                    }
                    onPhotoClick={() => onPhotoClick(index)}
                    getUploadedFiles={getUploadedFiles}
                    // formName={formName}
                    onConfirmUser={onConfirmUser}
                    mode={data.mode}
                    DepartmentHandler={departHandler}
                    saveDynamicTableData={saveDynamicTableData}
                    linkColumnName={linkColumnName}
                    linkColumnValue={linkColumnValue}
                  />
                ),
            )
          )}
        </div>
      </Form>
      <Button.Group>
        {cancelBtnMode !== 2 && (
          <Button
            disabled={cancelBtnMode === 0 || loader.submit}
            onClick={() => {
              setIsModalOpen(true);
              userStore.markloginDropDownTwo = false;
            }}
          >
            {cancelBtnName || 'Cancel'}
          </Button>
        )}
        {cancelBtnMode !== 2 && submitBtnMode !== 2 && <Button.Or />}
        {submitBtnMode !== 2 && (
          <>
            {commonStore.staticDemoChanges &&
            DynamicDashboardStore.staticSelectedCard === 'Asset Renting' ? (
              <PDFDownloadLink
                document={<LvpcmsInvoice formDetails={duplicateFormDetails} />}
                // document={<></>}
                fileName="LVPCMS_Rental_Invoice.pdf"
                className={
                  disableGenerateInvoice() || submitBtnMode === 0
                    ? 'genRep component-isDisabled'
                    : 'genRep'
                }
              >
                <Button
                  color="blue"
                  onClick={beforeSaveHandler}
                  style={{
                    borderTopLeftRadius: '0px',
                    borderBottomLeftRadius: '0px',
                  }}
                  loading={loader.submit}
                >
                  Generate Invoice & Save
                </Button>
              </PDFDownloadLink>
            ) : (
              <Button
                disabled={submitBtnMode === 0 || loader.submit}
                loading={loader.submit}
                color="blue"
                onClick={beforeSaveHandler}
              >
                {submitBtnName || 'Save'}
              </Button>
            )}
          </>
        )}
      </Button.Group>
    </div>
  );
}

export default FormComponentDyDb;
